import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from './classes/BaseService';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';

@Injectable()
export class FeedbackService extends BaseService{

  apiUrl = "Feedback.php";

  constructor(protected http: HttpClient) {
    super(http);
  }

  send(name: string, email: string, text: string, source: string = ""): Observable<any> {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("name", name),
      new UrlParam("email", email),
      new UrlParam("text", text),
      new UrlParam("source", source)
    );
    return this.post(url, params);
  }

}
